export const educationData = [{
        id: 1,
        institution: 'Masai School, Bangalore',
        course: 'Full Stack Web Development Course',
        startYear: '2021',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'K.L.S College Nawadah',
        course: 'Bacheolors of Arts',
        startYear: '2019',
        endYear: 'present'
    },
    {
        id: 3,
        institution: 'K.L.S College Nawadah',
        course: 'Intermediate Arts',
        startYear: '2017',
        endYear: '2019'
    },
]